<template>
  <div>
    <template v-if="loading">
      <content-placeholders>
        <content-placeholders-text :lines="10"/>
      </content-placeholders>
    </template>
    <template v-else-if="items.length">
      <div class="html2pdf__page-break"></div>
      <div class="catalog-view__etim">
        <div class="catalog-view__etim-head">
          <div class="catalog-view__subtitle catalog-view__subtitle-etim" id="etim">
            ETIM
              <svg content="ETIM — универсальный классификатор товаров используемый в электротехнической отрасли"
                   v-tippy="{ arrow : true,  animation : 'fade'}"
                   width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="7" stroke="#00AC86" stroke-width="2" />
                <line x1="12" y1="13" x2="12" y2="15" stroke="#00AC86" stroke-width="2" stroke-linecap="round" />
                <circle cx="12" cy="9" r="0.5" stroke="#00AC86" />
              </svg>
          </div>
          <a class="catalog-view__link catalog-view__link--lg" @click="showModal">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 15L5 18H19V15" stroke="#00AC86" stroke-width="2" />
              <path d="M15 11L12.0707 13.9293C12.0317 13.9683 11.9683 13.9683 11.9293 13.9293L9 11" stroke="#00AC86"
                    stroke-width="2" stroke-linecap="square" />
              <line x1="12" y1="14" x2="12" y2="5" stroke="#00AC86" stroke-width="2" />
            </svg>
            <span>Скачать все</span>
          </a>

          <a v-if="product.etimUrl" class="catalog-view__link catalog-view__link--lg" style="margin-left: auto" :href="product.etimUrl">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86"></path>
              <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2"></path>
            </svg>
            <span>Редактировать</span>
          </a>
        </div>

        <ul v-if="items.length > 1" class="catalog-view__tabs">
          <li :class="key === activeTab ? 'is-active' : ''" v-for="(item, key) in items" :key="key" @click="setTab(key)"> {{
              item.name
            }}
          </li>
        </ul>
        <div class="catalog-view__etim-row" v-if="product.etimClass">
          <div class="catalog-view__etim-text">ETIM CLASS</div>
          <div class="catalog-view__etim-text"><strong class="color-black">{{ product.etimClass.code }}</strong></div>
          <div class="catalog-view__etim-text"><strong class="color-black">{{ product.etimClass.name }}</strong>
          </div>
        </div>
        <div class="catalog-view__table catalog-view__table-etim">
          <table v-for="(item, key) in items" :key="key">
            <thead v-if="key === activeTab">
            <tr>
              <th colspan="2">Свойство (ETIM FEATURE)</th>
              <th colspan="2">Значение свойства (ETIM VALUE)</th>
              <th class="text-right" colspan="2">Ед. измерения (ETIM UNIT)</th>
            </tr>
            </thead>
            <tbody v-if="key === activeTab">
            <tr v-show="key < 5 || showAll" v-for="(feature, key) in item.values" :key="key">
              <td>{{ feature.feature.name || '-' }}</td>
              <td>{{ feature.feature.code || '-' }}</td>
              <td>
                <span v-if="feature.value.code">{{ feature.value.name || '-' }}</span>
                <span v-else>{{ feature.value.name || '-' }}</span>
              </td>
              <td>
                <span class="grey" v-if="feature.value.code">{{ feature.value.code || '-' }}</span>
                <span v-else>{{ feature.value || '-' }}</span>
              </td>
              <td>
                <span v-if="feature.unit">{{ feature.unit.name || '-' }}</span>
                <span v-else>-</span>
              </td>
              <td>
                <span class="grey" v-if="feature.unit">{{ feature.unit.code || '-' }}</span>
                <span class="grey" v-else>-</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="catalog-view__etim-mobile" v-for="(item, key) in items" :key="key">
          <div v-if="key === activeTab">
            <div class="catalog-view__etim-item" v-show="key < 5 || showAll" v-for="(feature, key) in item.values"
                 :key="key">
              <div class="catalog-view__etim-item-title">{{ feature.feature.name }} <span>{{
                  feature.feature.code
                }}</span></div>
              <div class="catalog-view__etim-item-row">
                <div class="catalog-view__etim-item-col">
                  Значение
                </div>
                <div class="catalog-view__etim-item-col">
                  <span v-if="feature.value.code">{{ feature.value.code }} <span>{{
                      feature.value.code
                    }}</span></span>
                  <span v-else>{{ feature.value }} <span>{{ feature.value }}</span></span>
                </div>
              </div>
              <div class="catalog-view__etim-item-row">
                <div class="catalog-view__etim-item-col">
                  Ед. изм.
                </div>
                <div class="catalog-view__etim-item-col">
                  <div v-if="feature.unit">
                    {{ feature.unit.name }} <span>{{ feature.unit.code }}</span>
                  </div>
                  <div v-else>-</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="catalog-view__show-more" @click="toggle()">
          <span v-if="!showAll">Развернуть</span>
          <span v-if="showAll">Свернуть</span>
          <svg v-if="!showAll" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 6L7.99999 10.5L4 6" stroke="#00AC86" stroke-width="2"></path>
          </svg>
          <svg v-if="showAll" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 11L8 6.49998L4 11" stroke="#00AC86" stroke-width="2"></path>
          </svg>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import {EVENT_ADD_CHIPS} from "../../views/ProductCard";

export default {
  name: 'etim',
  components: {},
  props: {
    product: {
      require: true
    }
  },
  data: () => ({
    items: [],
    loading: true,
    activeTab: 0,
    showAll: false
  }),
  created() {
    this.$api.product.etim(this.product.id).then((response) => {
      if (response && response.data) {
        this.items = response.data
        if (this.items.length) {
          this.$emit(EVENT_ADD_CHIPS, {
            link: 'etim',
            title: 'ETIM',
            size: null,
            order: 4
          })
        }
      }
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  },
  methods: {
    setTab(value) {
      this.activeTab = value
    },
    showModal() {
      this.$root.$emit('product-archive-modal::show', {categories: ["characteristics"]})
    },
    toggle() {
      this.showAll = !this.showAll
    }
  }
}
</script>